import React from "react";


export default function DwgViewerModePill({
    viewerMode,
    setViewerMode
})
{
    const pillBar =
    {
        position: "absolute",
        top: "12px",
        left: "50%",
        transform: "translateX(-50%)",

        display: "flex",
        alignItems: "center",
        gap: "4px",

        padding: "5px",

        background: "rgba(255,255,255,0.86)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",

        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: "999px",

        boxShadow: "0 8px 28px rgba(0,0,0,0.18)",

        zIndex: 100
    };


    const pill =
            (mode) =>
            ({
                border: "none",
                outline: "none",

                padding: "9px 24px",

                borderRadius: "999px",

                fontSize: "13px",
                fontWeight: "600",

                cursor: "pointer",

                color:
                    viewerMode === mode
                        ? "#ffffff"
                        : "#333333",

                background:
                    viewerMode === mode
                        ? "linear-gradient(135deg, #1597ff 0%, #0066d6 100%)"
                        : "transparent",

                boxShadow:
                    viewerMode === mode
                        ? "0 4px 14px rgba(0,102,214,0.32)"
                        : "none",

                transition:
                    "all 0.2s ease"
            });


    return (
        <div style={pillBar}>

            <button
                style={pill("pdf")}
                onClick={() =>
                    setViewerMode(
                        "pdf")
                }
            >
                PDF
            </button>


            <button
                style={pill("finder")}
                onClick={() =>
                    setViewerMode(
                        "finder")
                }
            >
                Finder
            </button>


            <button
                style={pill("autodesk")}
                onClick={() =>
                    setViewerMode(
                        "autodesk")
                }
            >
                Autodesk
            </button>

        </div>
    );
}